<template>
  <div class="login">
    <vue-headful
    title="Login Page - Alabama.Travel"
    description="Login to view your account, saved road trips, favorites and trip plans."
    url="https://alabama.travel/login"/>
    <div class="container">
      <div class="d-flex flex-row justify-content-center">
        <div class="">
          <div class="hello">Hello!</div>
          <div class="welcome-back">Welcome back.</div>
          <input @click="showEmailHelp" id="emailAddress" type="email" v-model="email" placeholder="Email Address" class="input-container email-address" :aria-invalid="invalidEmail" />
          <div class="help-error" aria-live="polite">
            <span>{{this.emailMessage}}</span>
          </div>
          <div class="password-wrapper">
          <input @click="showPasswordHelp" id="password" :type="type" v-model="password" placeholder="Password" class="input-container input-container-password password" :aria-invalid="invalidPassword" />
          <button @click='showPassword' :class="btnClass"></button>
          </div>
          <div class="help-error" aria-live="polite">
            <span>{{this.passwordMessage}}</span>
          </div>
          <button @click="login" :disabled="disabledLogin" class="login-btn"><span class="login-text">Sign In</span></button>
          <div class="reset-password-tx"><router-link to="/forgot-password" class="forget-password">Reset your password</router-link></div>
          <div class="or-continue-tx">Or continue with</div>
          <div class="social">
            <img src="../assets/apple-logo.svg" class="social-icons" alt="Apple Logo" @click="loginApple" />
            <img src="../assets/facebook-logo.svg" class="social-icons" alt="Facebook Logo" @click="loginFacebook" />
            <img src="../assets/google-logo.svg" class="social-icons" alt="Google Logo" @click="loginGoogle" />
          </div>
          <div class="already-member">Not a member? <router-link to="/signup" class="sign-up">Register now!</router-link></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';

export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      userEmail: '',
      userId: '',
      loginMessage: '',
      btnText: 'Show',
      type: 'password',
      btnClass: 'openIcon',
      redirect: '',
      disabledLogin: false,
      emailMessage: '',
      passwordMessage: '',
      emailHelp: false,
      passwordHelp: false,
      invalidEmail: false,
      invalidPassword: false,
    };
  },
  methods: {
    async loginFacebook() {
      Auth.federatedSignIn({ provider: 'Facebook' });
    },
    async loginGoogle() {
      Auth.federatedSignIn({ provider: 'Google' });
    },
    async loginApple() {
      Auth.federatedSignIn({ provider: 'SignInWithApple' });
    },
    async login() {
      try {
        this.validateInput();
        await Auth.signIn(this.email, this.password);
        this.$router.push('/');
      } catch (err) {
        switch (err.message) {
          case 'Username cannot be empty':
            this.emailMessage = 'Your email address is required.';
            this.invalidEmail = true;
            this.disabledLogin = false;
            break;
          case 'User does not exist.':
            this.emailMessage = 'Double check your email address.';
            this.invalidEmail = true;
            this.disabledLogin = false;
            break;
          case 'Custom auth lambda trigger is not configured for the user pool.':
            this.passwordMessage = 'Please enter a password.';
            this.invalidPassword = true;
            this.disabledLogin = false;
            break;
          case 'Incorrect username or password.':
            this.passwordMessage = 'Incorrect username or password.';
            this.invalidPassword = true;
            this.disabledLogin = false;
            break;
          default:
            this.passwordMessage = err.message;
            this.invalidPassword = true;
            this.disabledLogin = false;
            break;
        }
      }
    },
    validateInput() {
      this.emailMessage = '';
      this.passwordMessage = '';
      this.emailHelp = false;
      this.passwordHelp = false;
      this.disabledLogin = true;
      if (this.email === '') {
        this.emailMessage = 'Your email address is required.';
        this.disabledLogin = false;
        return;
      } if (this.validEmail(this.email) === false) {
        this.emailMessage = 'Double check your email address.';
        this.disabledLogin = false;
        return;
      }
      if (this.password === '') {
        this.passwordMessage = 'Please enter a password.';
        this.disabledLogin = false;
      }
    },
    showPassword() {
      if (this.type === 'password') {
        this.type = 'text';
        this.btnText = 'Hide';
        this.btnClass = 'closeIcon';
      } else {
        this.type = 'password';
        this.btnText = 'Show';
        this.btnClass = 'openIcon';
      }
    },
    validEmail(email) {
      // eslint-disable-next-line
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const result = re.test(email);
      return result;
    },
    showEmailHelp() {
      this.emailMessage = '';
      this.emailHelp = true;
    },
    showPasswordHelp() {
      this.passwordMessage = '';
      this.passwordHelp = true;
    },
  },
};
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
  .hello {
    width: 92px;
    height: 30px;
    margin: 0 auto;
    font-family: IdealSans-Medium;
    font-size: 30px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.83px;
    color: #173945;
  }
  .welcome-back {
    width: 179px;
    height: 24px;
    margin: 10px auto;
    font-family: IdealSans-Medium;
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.67px;
    color: #173945;
  }
  .input-container {
    width: 300px;
    height: 50px;
    margin: 62px 0 4px;
    padding: 18px 12px;
    border-radius: 8px;
    border: solid 1px #979797;
    background-color: #fff;
    color: black;
  }
  .input-container::placeholder {
    color: black;
    opacity: 1;
  }
  .input-container-password {
    width: 300px;
    margin-top: 5px;
    margin-left: 60px;
  }
  .email-address, .password  {
    font-family: IdealSans-Medium;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.39px;
    color: #000;
  }
  .help-error {
    width: 300px;
    height: 12px;
    margin: 7px 0 30px 75px;
    font-family: IdealSans-Medium;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.33px;
    text-align: left;
    color: #000;
  }
  .login-btn {
    width: 300px;
    height: 61px;
    padding: 18px 115px 19px 116px;
    border-radius: 8px;
    border: solid 1px #979797;
    background-color: #173945;
    cursor: pointer;
  }
  .login-text {
    width: 69px;
    height: 18px;
    font-family: IdealSans-Medium;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.5px;
    text-align: center;
    color: #f7f6f1;
  }
   .login-btn:focus {
    outline: 2.75px dotted !important;
    outline-color: #4c8ea0 !important;
    outline-offset: 3px !important;
  }
  .login-btn:hover {
    box-shadow: 0px 0px 3px #173945;
  }
   .or-continue-tx {
    height: 14px;
    font-family: IdealSans-Medium;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.39px;
    text-align: center;
    color: #000;
  }
  .already-member {
    height: 14px;
    margin-top: 96px;
    margin-bottom: 188px;
    font-family: IdealSans-Medium;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.39px;
    text-align: center;
    color: #000;
  }
  .reset-password-tx {
    height: 14px;
    margin: 28px 85px 60px 86px;
    font-family: IdealSans-Medium;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.39px;
    text-align: center;
    color: #a5b1b6;
  }
  .social {
    margin-top: 18px;
  }
  .social-icons {
    margin-left: 19px;
    margin-right: 19px;
    padding: 10px;
  }
  .social-icons:hover {
    border-radius: 50%;
    outline: 2.75px dotted !important;
    outline-color: #4c8ea0 !important;
    outline-offset: 3px !important;
    margin-left: 19px;
    margin-right: 19px;
  }
  .forget-password, .sign-up {
    text-decoration: none;
  }
  .forget-password:visited {
    color: #a5b1b6;
  }
  .sign-up:visited {
    color: #173945;
  }
  .forget-password:hover, .sign-up:hover {
    text-decoration: underline;
  }
  .password-wrapper {
    display:flex;
    flex-direction:row;
    padding:0px!important;
  }
  .login {
    margin-top: 40px;
  }
  input {
    margin: 0px 0 10px 0px;
    padding: 15px;
  }
  label {
    margin-bottom: 0px;
    font-size:14px;
    font-style: italic;
  }

  button, .social-icons {
    cursor: pointer;
  }
  .btn-sign-in {
    padding: 15px 35px 10px 35px;
    margin:0px 5px 10px 0px;
  }
  .reset-button {
    padding: 15px 35px 10px 35px;
    margin:10px 0px 0px 5px;
  }
  p {
    margin-top: 40px;
    font-size: 14px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }
  .openIcon, .closeIcon {
    border:none;
    width:60px;
  }
  .openIcon {
    background-image: url(/images/icons/eye-hidden.svg);
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: center;
  background-color: transparent;
  position: relative;
  left: -50px;
  }
  .closeIcon {
    background-image: url(/images/icons/eye-visible.svg);
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: center;
  background-color: transparent;
  position: relative;
  left: -50px;
  }
  @media only screen and (max-width: 768px) {
    .reset-button {
    padding: 15px 35px 10px 35px;
    margin:10px 0px 0px 0px;
  }
}
</style>
